import { createGlobalState } from 'react-use';

type StationId = string | undefined;

const useGlobalActiveWindStationState = createGlobalState<StationId>();

const useActiveWindStation = () => useGlobalActiveWindStationState();

export default useActiveWindStation;
